import { fromJS } from 'immutable';
import {
  FETCH_USERS,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  DEACTIVATE_USER,
  DEACTIVATE_USER_SUCCESS,
  DEACTIVATE_USER_FAILURE,
  REACTIVATE_USER,
  REACTIVATE_USER_SUCCESS,
  REACTIVATE_USER_FAILURE,
} from './constants';

export const initialState = fromJS({
  users: [],
  loading: false,
  error: '',
  actionLoading: false,
  actionError: '',
});

function manageAccountStatusReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_USERS:
      return state.set('loading', true).set('error', '');
    case FETCH_USERS_SUCCESS:
      return state.set('loading', false).set('users', fromJS(action.users));
    case FETCH_USERS_FAILURE:
      return state.set('loading', false).set('error', action.error);
    case DEACTIVATE_USER:
    case REACTIVATE_USER:
      return state.set('actionLoading', true).set('actionError', '');
    case DEACTIVATE_USER_SUCCESS:
    case REACTIVATE_USER_SUCCESS:
      return state.set('actionLoading', false);
    case DEACTIVATE_USER_FAILURE:
    case REACTIVATE_USER_FAILURE:
      return state.set('actionLoading', false).set('actionError', action.error);
    default:
      return state;
  }
}

export default manageAccountStatusReducer;
